import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Drawer from "./Drawer"; // Drawer 컴포넌트(top & bottom)
import Main from "../Pages/Main"; // 메인 페이지
import MyPage from "../Pages/MyPasge"; // 마이페이지
import SearchResult from "../Pages/SearchResult"; // 검색 결과 페이지
import Watch from "../Pages/Watch"; // 교육 영상 페이지
import Login from "../Pages/Login"; // 로그인 페이지
import LoginMobile from "../Pages/Login/LoginMobile"; // 로그인 모바일 페이지
import SignUp from "../Pages/Login/SignUp"; // 회원가입 페이지
import Education from "../Pages/Education"; // 사업장 선택 페이지
import Calendars from "../Pages/Education/Calendars"; // MY 교육 현황 페이지
import SelectedSite from "../Pages/Education/SelectedSite"; // 현장 선택 페이지
import Composed from "../Pages/Education/Composed"; // 현장 선택 및 기본 정보 입력, 조회 페이지
import WatchEducation from "../Pages/Education/watchEducation"; // 교육 영상 페이지
import HealthInterview from "../Pages/Education/HealthInterview"; // 보건 서류 페이지
import HealthDocument from "../Pages/Education/HealthDocument"; // 보건 서류 페이지
import Constructions from "../Pages/Education/Constructions"; // 위험성 평가 페이지
import Error from "../Error"; // 에러 페이지
import AuthGuard from "../Components/AuthGuard"; // 권한 확인 컴포넌트

// 통합된 라우트 설정
const routes = [
  {
    path: "/",
    Component: Drawer,
    children: [
      { index: true, element: <Main /> },
      { path: "/main", element: <Main /> },
      { path: "/my-page", element: <MyPage /> },
      { path: "/search-result", element: <SearchResult /> },
      { path: "/watch", element: <Watch /> },
      {
        path: "/login",
        element: (
          <AuthGuard path='/login'>
            <Login />
          </AuthGuard>
        ),
      },
      {
        path: "/m-login",
        element: <LoginMobile />,
      },
      {
        path: "/signup",
        element: (
          <AuthGuard path='/signup'>
            <SignUp />
          </AuthGuard>
        ),
      },
      {
        path: "/selected-company",
        element: (
          <AuthGuard path='/selected-company'>
            <Education />
          </AuthGuard>
        ),
      },
      {
        path: "/selected-site",
        element: (
          <AuthGuard path='/selected-site'>
            <SelectedSite />
          </AuthGuard>
        ),
      },
      {
        path: "/composed-education",
        element: (
          <AuthGuard path='/composed-education'>
            <Composed />
          </AuthGuard>
        ),
      },
      {
        path: "/watch-education",
        element: (
          <AuthGuard path='/watch-education'>
            <WatchEducation />
          </AuthGuard>
        ),
      },
      {
        path: "/health-interview",
        element: (
          <AuthGuard path='/health-interview'>
            <HealthInterview />
          </AuthGuard>
        ),
      },
      {
        path: "/health-document",
        element: (
          <AuthGuard path='/health-document'>
            <HealthDocument />
          </AuthGuard>
        ),
      },
      {
        path: "/construction-test",
        element: (
          <AuthGuard path='/construction-test'>
            <Constructions />
          </AuthGuard>
        ),
      },
      {
        path: "/my-calendar",
        element: (
          <AuthGuard path='/my-calendar'>
            <Calendars />
          </AuthGuard>
        ),
      },
    ],
  },
  { path: "/error-page", element: <Error /> },
  // 404 페이지도 error-page로 리다이렉트
  { path: "*", element: <Error /> },
];

function Router() {
  return <RouterProvider router={createBrowserRouter(routes)} />;
}

export default Router;
